<template>
  <el-dialog
    :model-value="visible"
    class="dialog-inner-scroller min-h-[169px]"
    align-center
    :before-close="close"
    width="460"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[#344767] font-semibold">
          修改有效期
        </h4>
      </div>
    </template>
    <el-form
      ref="formRef"
      require-asterisk-position="right"
      class="add-platform-users-form"
      label-position="top"
      :model="form"
      :rules="formRules"
    >
      <el-form-item
        label="本人授权有效期"
        prop="hnAuthDate"
        class="!mb-0"
      >
        <el-select 
          v-model="form.hnAuthDate" 
          placeholder="本人授权有效期" 
          clearable 
          filterable
        >
          <el-option label="未认证" value="true" />
          <el-option label="1天" value="1天" />
          <el-option label="2天" value="2天" />
          <el-option label="3天" value="3天" />
          <el-option label="4天" value="4天" />
          <el-option label="5天" value="5天" />
          <el-option label="6天" value="6天" />
          <el-option label="7天" value="7天" />
          <el-option label="认证过期" value="认证过期" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="flex justify-end mr-6">
        <el-button @click="close">
          取消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { FormInstance } from 'element-plus';
import { ref, watch } from 'vue';
import { EApproveStatus } from '@core/main/types/common';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  status: {
    type: Number as () => EApproveStatus,
    default: EApproveStatus.SUCCESS,
  },
});

const formRef = ref<FormInstance>();
const form = ref({ hnAuthDate: undefined });
const formRules = ref({
  hnAuthDate: [
    {
      required: true,
      message: '请选择本人授权有效期', 
    },
  ], 
});

async function doSubmit() {
  emit('confirm', form.value.hnAuthDate);
  close();
}

function handleSubmit() {
  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

function close() {
  form.value.hnAuthDate = undefined;
  emit('close');
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {

    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>

</style>
